import z from "zod";

const count = z.number().int().nonnegative();

/**
 * The counts the work agreement list shows, from `GET /work/counts` (#6709): current work, and the
 * archive with the views of work the reader left. Each takes the list's own criteria, and neither
 * moves with the Archived chip (#6716).
 */
export const WorkAgreementListCountsJSONZ = z.object({
  active: count,
  archived: count,
});

export type WorkAgreementListCounts = z.infer<typeof WorkAgreementListCountsJSONZ>;
